// extracted by mini-css-extract-plugin
export default {"windyEmbed__container":"Windy_windyEmbed__container__uqAKP","windyEmbed__iframe":"Windy_windyEmbed__iframe__x7VbM"};